import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core'
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import {
  PagedContactTypeResponse,
  SearchContactTypeModel,
} from '../../../core/models/contact-type.model'
import { MatButton } from '@angular/material/button'
import { MatFormField, MatFormFieldModule, MatLabel } from '@angular/material/form-field'
import { MatInput, MatInputModule } from '@angular/material/input'
import { MatSelectModule } from '@angular/material/select'


import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog'
import { DocumentTypeService } from '../../../core/services/document/document-type/document-type.service'
import { MatIconModule } from '@angular/material/icon'
import { MatDatepickerModule } from '@angular/material/datepicker'
import { MatNativeDateModule } from '@angular/material/core'
import { CommonModule } from '@angular/common';
import { MatTableModule } from '@angular/material/table'
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask'
import { PassengerService } from '../../../core/services/passenger/passenger.service'
import { PassengerOrdemService } from '../../../core/services/passenger/passenger-os/passenger-os.service'
import { MatSpinner } from '@angular/material/progress-spinner'
import { SnackbarCustomService } from '../../../shared/components/snackbar/snackbar-custom.service'
import { OccurrenceTypeService } from '../../../core/services/occurrence/occurrence-type/occurrence-type.service'
import { OccurrenceService } from '../../../core/services/occurrence/occurrences/occurrences.service'
import { OccurrenceOsService } from '../../../core/services/occurrence/occurrences-os/occurrences-os.service'

@Component({
  selector: 'occurrences-modal-create',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatSelectModule,
    MatButton,
    MatFormField,
    MatInput,
    MatLabel,
    MatSelectModule,
    MatIconModule,
    MatTableModule,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    MatNativeDateModule,
    NgxMaskDirective,
    MatSpinner

  ],
  templateUrl: './occurrences-modal-create.component.html',
  styleUrl: './occurrences-modal-create.component.scss',
  standalone: true,
  providers: [provideNgxMask({
    dropSpecialCharacters: false
  })],
})
export class OccurrencesModalCreateComponent implements OnInit {
  constructor(
    private formBuilder: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<OccurrencesModalCreateComponent>,
    private dialog: MatDialog,
    private passangerService: PassengerService,
    private passangerOs: PassengerOrdemService,
    private documentTypeService: DocumentTypeService,
    private snackbar: SnackbarCustomService,
    private occurrenceTypeService: OccurrenceTypeService,
    private occurrenceService: OccurrenceService,
    private occurrenceOsService: OccurrenceOsService,
  ) { }

  @Output() response = new EventEmitter<any>()

  form!: FormGroup;
  passengers: any[] = []; // Agora a lista vem da API
  loading = false;

  documentMask = '';

  listTypeOccurrence: any = []
  listOccurrence: any = []
  page = 1;
  rows = 10;
  numberRows = 0;
  itemsList: any[] = []
  passengerOsList: any[] = []
  searchForm: SearchContactTypeModel = new SearchContactTypeModel()
  idForOs: any = ""
  editIndex: number | null = null;
  editAgendaItem: any = null;

  ngOnInit(): void {
    this.createForm();
    this.listTypeOccurrences()
    this.listOcccurrences()

  }

  listOcccurrences() {
    this.occurrenceService.listOccurrence().subscribe({
      next: (res) => {
        this.listOccurrence = res.data
      },
    })
  }

  listTypeOccurrences() {
    this.occurrenceTypeService.listOccurrenceType().subscribe({
      next: (res) => {
        this.listTypeOccurrence = res.data
      },
    })
  }

  registerOccurrences() {
    this.loading = true
    const data = this.createModal()

    this.occurrenceOsService.createOccurrenceServiceOrder(data).subscribe({
      next: (res) => {
        this.snackbar.success(res.message)
        this.response.emit(res)
        this.loading = false
        this.closeModal()
      },
      error: (error: any) => {
        this.loading = false
        this.snackbar.errorRequest(error)
      }
    })
  }

  createForm(): void {
    this.form = this.formBuilder.group({
      codeOs: this.data.codigoOs,
      codeTg: this.data.codigoTg,
      typeOccurrence: ['', [Validators.required]],
      // ocorrenciaId deixou de ser obrigatório — o tipoOcorrenciaId já diz o que
      // aconteceu, e exigir o subtipo travava o registro em campo.
      occurrence: [''],
      date: ['', [Validators.required]],
      hour: [''],
      observation: [''],
    });
  }

  formatHours(hours: any) {
    return `${hours}:00`;
  }

  //Formatar a data que vem como string 00/00/00 para o formato que o input mat-datapciker aceita
  formatDate(dateString: string): Date | null {
    const dateParts = dateString.split('/');
    if (dateParts.length === 3) {
      const day = parseInt(dateParts[0], 10);
      const month = parseInt(dateParts[1], 10) - 1;
      const year = parseInt(dateParts[2], 10);
      return new Date(year, month, day);
    }
    return null;
  }



  closeModal() {
    this.dialogRef.close();
  }


  getListItems() {
    this.loading = true
    this.passangerService
      .listPagedPassenger(this.page, this.rows)
      .subscribe({
        next: (response: any) => {
          this.treatResponse(response)
        },
        error: (err: PagedContactTypeResponse) => { },
        complete: () => {
          this.loading = false
        },
      })
  }



  treatResponse(response: any) {
    const list = []
    if (response.data) {
      for (const item of response.data) {
        list.push(item)
      }
    }
    this.itemsList = list
    this.numberRows = response.totalItens
  }

  formatDateBase(date: string): string {
    const dateObject = new Date(date);
    const day = dateObject.getDate().toString().padStart(2, '0');
    const month = (dateObject.getMonth() + 1).toString().padStart(2, '0');
    const year = dateObject.getFullYear();
    // Pega os dois últimos dígitos do ano

    return `${day}/${month}/${year}`;
  }




  createModal() {
    return {
      ordemServicoId: this.form.get('codeOs')?.value,
      tipoOcorrenciaId: this.form.get('typeOccurrence')?.value,
      // O normal agora é não mandar — subtipo é opcional. Se mandar, tem que ser um id válido.
      ocorrenciaId: this.form.get('occurrence')?.value || null,
      dataOcorrido: this.formatDateBase(this.form.get('date')?.value),
      horaOcorrido: this.formatHours(this.form.get('hour')?.value),
      observacao: this.form.get('observation')?.value
    }
  }


  getPassengersFromApi(): void {
    this.loading = true;


    this.passangerOs.listPagedPassengerOs(this.page, this.rows).subscribe({
      next: (res) => {


        this.passengers = res.data || [];
        this.numberRows = res?.data?.length || 0;
        this.loading = false;


      },
      error: () => {
        this.loading = false;
        console.error('Erro ao buscar passageiros');
      }
    });
  }







  resetForm() {
    this.form.reset();
  }
}
